import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { CardApiModelStub } from '../api-models/stubs/CardApiModel.stub'

export const mockGetMyCardsSuccess = (
  cardStubs = CardApiModelStub.buildList(2)
) => {
  return rest.get(`/api/v3/pay/cards/`, (_, res, ctx) => {
    return res.once(ctx.status(200), ctx.json(getResponseObject(cardStubs)))
  })
}
